import React from 'react';

import {observer} from "mobx-react";
import {ToggleButton, ToggleButtonProps} from "../misc/toggle/toggle-button";
import {
  OddsTypeDropdown,
  OddsTypeDropdownProps
} from "../odds/odds-type-dropdown/odds-type-dropdown";
import {ODDS_TYPES} from "../odds/components/odds-consts";
import {Tooltip} from "../tooltip/tooltip";
import {ScoresListWidgetHeaderDesktopProps} from "./scores-header";
import classnames from "classnames";

export class ScoresHeaderDesktopOddsProps extends ScoresListWidgetHeaderDesktopProps {
  toggleClassName: String;
}

export const ScoresHeaderOdds = observer((props: ScoresHeaderDesktopOddsProps) => {
  const toggleProps: ToggleButtonProps = {
    className: classnames(props.toggleClassName),
    active: props.showOdds,
    label: props.controller.state.terms.SETTINGS_ODDS,
    onClick: () => props.onToggleOdds()
  }

  const toggleTooltipProps = {
    title: props.showOdds ? props.controller.state.terms.WEB_TOOLTIP_ODDS_OFF : props.controller.state.terms.WEB_TOOLTIP_ODDS_ON
  }

  const dropdownTooltipProps = {
    className: 'scores-header-odds-menu'
  }

  const oddsTypeDropdownProps: OddsTypeDropdownProps = {
    onOddsChange: (oddsType: ODDS_TYPES) => props.onOddsChange(oddsType),
    selectedOddsType: props.selectedOddsType,
  }

  return (
    <div className={'scores-header-odds'}>
      <Tooltip {...toggleTooltipProps}>
        <ToggleButton {...toggleProps} />
      </Tooltip>
      <div {...dropdownTooltipProps}>
        <OddsTypeDropdown {...oddsTypeDropdownProps}/>
      </div>
    </div>
  )
});
